import React from "react";

import LocationStepOne from "img/how-to-img/circle-location.png";
import InfoStepTwo from "img/how-to-img/info.png";
import managerStepThree from "img/how-to-img/manager.png";
import AcceptStepFour from "img/how-to-img/accept.png";
import ApproveStepFive from "img/how-to-img/approve.png";

export default function HowToTraveller() {
  return (
    <div className="step-list">
            <h1 className="small-heading">Steps to Register a Company</h1>
      <div className="step-item icon-left">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={LocationStepOne}
            alt="Step One"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 1: Navigate to the Corporate Registration Page
          </h1>
          <p className="small-para">
            Go to the Tripple Air homepage and click on "Corporate" or "Business
            Accounts" at the top menu. This will take you to the dedicated
            company registration portal.
          </p>
        </div>
      </div>
      <div className="step-item icon-right">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={InfoStepTwo}
            alt="Step Two"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 2: Fill In Company Information
          </h1>
          <p className="small-para">
            Enter your company name, business email, contact number, and company
            address. You may also need to provide a tax ID or business
            registration number to verify your legal entity.
          </p>
        </div>
      </div>
      <div className="step-item icon-left">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={managerStepThree}
            alt="Step Three"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 3: Assign an Account Manager
          </h1>
          <p className="small-para">
            Provide the name and email of the person who'll manage the corporate
            account. They'll be responsible for booking tickets, managing
            invoices, and accessing exclusive business tools.
          </p>
        </div>
      </div>
      <div className="step-item icon-right">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={AcceptStepFour}
            alt="Step Four"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 4: Accept Terms & Submit
          </h1>
          <p className="small-para">
            Review the corporate terms and conditions, tick the box to agree,
            and hit "Submit." This sends your company's request to Tripple Air
            for approval.
          </p>
        </div>
      </div>
      <div className="step-item icon-left">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={ApproveStepFive}
            alt="Step Five"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 5: Account Approval & Welcome Email
          </h1>
          <p className="small-para">
            You'll receive an approval email once your corporate account is
            reviewed (usually within 1-2 business days). Follow the login link,
            set your password, and you're all set to start booking with business
            perks and corporate rates!
          </p>
        </div>
      </div>
    </div>
  );
}
